import React from 'react';
import { ElectronicPrescriptionPolandFormValues } from './ElectronicPrescriptionPolandAddMedicamentForm';
import RemoveButton from '../../../../Components/Button/RemoveButton';
// @ts-ignore
import styles from './ElectronicPrescriptionPolandMedicationsList.module.scss';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import Text from '../../../../Components/Base/Text/Text';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	medications: ElectronicPrescriptionPolandFormValues[];
	onRemove: (id: string) => void;
}

interface Item {
	label: string;
	value?: string | React.ReactNode;
}

const ItemComponent: React.FC<Item> = ({ label, value }) => {
	const { t } = useTranslation();

	if (!value) {
		return <></>;
	}

	if (typeof value === 'string') {
		value = t(value);
	}

	return (
		<div className={styles.subItem}>
			<Text className={styles.label} tx={label} colon />
			<div className={styles.value}>{value}</div>
		</div>
	);
};

const ElectronicPrescriptionPolandMedicationsList: React.FC<Props> = ({
	medications,
	onRemove,
}) => {
	return (
		<div className={styles.wrapper}>
			{medications.map(item => {
				return (
					<div className={styles.item} key={item.id}>
						<div className={styles.content}>
							<div className={styles.title}>{item.medicament.label}</div>
							<div className={styles.subItems}>
								<ItemComponent
									label='component.electronicPrescriptionPoland.medicament'
									value={item.paymentCoverage.label}
								/>
								<ItemComponent
									label='component.electronicPrescriptionPoland.medicamentChange'
									value={item.medicamentChange ? 'base.yes' : 'base.no'}
								/>
								<ItemComponent
									label='component.electronicPrescriptionPoland.validFrom'
									value={
										<FormattedMomentDate
											date={item.validFrom}
											format={DateFormat.DATE}
										/>
									}
								/>
								<ItemComponent
									label='component.electronicPrescriptionPoland.recipeRepeat'
									value={item.recipeRepeat}
								/>
								<ItemComponent
									label='component.electronicPrescriptionPoland.amountOfPackages'
									value={item.amountOfPackages}
								/>
								<ItemComponent
									label='component.electronicPrescriptionPoland.dosageCount'
									value={item.dosageCount}
								/>
								<ItemComponent
									label='component.electronicPrescriptionPoland.dosageInterval'
									value={item.dosageInterval.label}
								/>
							</div>
						</div>
						<div className={styles.controls}>
							<RemoveButton onClick={() => onRemove(item.id)} />
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default ElectronicPrescriptionPolandMedicationsList;
